<template>
  <div id="app">
    <b-container>
      <router-view />
      <browser-check />
    </b-container>
  </div>
</template>

<script>
import BrowserCheck from "@/components/BrowserCheck";

export default {
  components: { BrowserCheck }
};
</script>

<style lang="scss"></style>
